import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { Paginator } from 'primeng/paginator';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { UserService } from 'src/app/admin/core/services/user.service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';

interface PageEvent {
  first: number;
  rows: number;
  page: number;
  pageCount: number;
}

@Component({
  selector: 'app-members',
  templateUrl: './members.component.html',
  styleUrls: ['./members.component.css']
})
export class MembersComponent implements OnInit {
  formPagination!: FormGroup;
  formFilter!: FormGroup;
  @ViewChild('paginator1', { static: false }) paginator1: Paginator;
  @ViewChild('paginator2', { static: false }) paginator2: Paginator;
  @ViewChild('containerCategories') containerMembers: ElementRef | undefined;
  autocompleteSearchlistMembers: any[] = [];
  private searchMember$ = new Subject<string>();
  listRows: any[] = [21, 42, 84];
  listMembers: any[] = [];
  loadingStatus = false
  totalPages = 0;
  first1: number = 0;

  rows1: number = 10;

  first2: number = 0;

  rows2: number = 10;

  first3: number = 0;

  rows3: number = 10;

  totalRecords: number = 120;

  rows: number = 1; // Số hàng mặc định mỗi trang
  isUpdating = false;
  currentPage = 0;

  rowsPerPageOptions: number[] = [1, 2, 3]; // Các tùy chọn số hàng mỗi trang
  constructor(private _fb: FormBuilder,
    private dynamicDocumentService: DynamicDocumentService,
    private router: Router,
    public userService: UserService
  ) {
    this.setSearchPipe();
  }
  ngOnInit(): void {
    this.formPagination = this._fb.group({
      rows: [21],
      page: [1],
    });
    this.formFilter = this._fb.group({
      code: [],
      companyName: [],
      postcode: [],
    });
    this.getListMemberSimple()
  }
  ngAfterViewInit() {
    this.updatePaginators(this.currentPage);
  }
  onPageChange(event: PageEvent) {
    if (this.isUpdating) {
      return;
    }

    this.isUpdating = true;
    this.currentPage = event.page;
    this.rows3 = this.formPagination.value.rows;
    this.formPagination.patchValue({
      page: event.page + 1
    });
    this.paginator1?.changePage(this.currentPage);
    this.paginator2?.changePage(this.currentPage);
    this.getListMemberSimple();
    this.isUpdating = false;
    this.containerMembers?.nativeElement?.scrollIntoView({ behavior: 'smooth' });
  }
  updatePaginators(page: number) {
    this.paginator1?.changePage(page);
    this.paginator2?.changePage(page);
  }
  filterRows(): void {
    this.formPagination.patchValue({
      rows: this.formPagination.value.rows,
      // page: 1,
    })
    this.getListMember();
    this.paginator1?.changePageToFirst(event);
    this.paginator2?.changePageToFirst(event);
  }
  getListMember(): void {
    let filters = [
      {
        fieldName: 'companyName',
        conditions: [{ type: 'CONTAINS', value: this.formFilter.value.companyName ? this.formFilter.value.companyName : '' }],
      },
      {
        fieldName: 'code',
        conditions: [{ type: 'CONTAINS', value: this.formFilter.value.code ? this.formFilter.value.code : '' }],
      },
      {
        fieldName: 'postcode',
        conditions: [{ type: 'CONTAINS', value: this.formFilter.value.postcode ? this.formFilter.value.postcode : '' }],
      },
      {
        fieldName: 'typeOfLegalEntity',
        conditions: [
          {
            type: 'EQUALS',
            value: 'ADHERENT',
          },
        ],
      },
      {
        fieldName: 'status',
        conditions: [
          {
            type: 'EQUALS',
            value: 'Publié',
          },
        ],
      },
    ];
    this.dynamicDocumentService
      .find({
        collectionName: 'dynamic_legal_entity',
        filters: filters,
        sorts: {
          publishedOrder: 'DESC',
        },
        page: this.formPagination.value.page,
        pageSize: this.formPagination.value.rows,
      })
      .subscribe((res: any) => {
        this.listMembers = res.content;
        this.totalRecords = res.totalElements
        this.rows3 = res.size;
        this.totalPages = Math.ceil(this.totalRecords / this.rows3);
      });
  }

  getListMemberSimple(): void {

    this.dynamicDocumentService
      .findLegalEntity({
        collectionName: 'dynamic_legal_entity',
        sortField:"publishedOrder",
        sortOrder:"DESC",
        typeOfLegalEntity:"ADHERENT",
        status:"Publié",
        page: this.formPagination.value.page,
        pageSize: this.formPagination.value.rows,
      })
      .subscribe((res: any) => {
        this.listMembers = res.content;
        this.totalRecords = res.totalElements
        this.rows3 = res.size;
        this.totalPages = Math.ceil(this.totalRecords / this.rows3);
      });
  }
  onSearchInput(): void {
    this.searchMember$.next(this.formFilter.value.companyName);
  }
  setSearchPipe() {
    this.searchMember$
      .pipe(
        debounceTime(300), // 300ms delay
        distinctUntilChanged()
      )
      .subscribe((searchMember: string) => {
        if (searchMember && searchMember.length >= 2) {
          this.dynamicDocumentService
            .find({
              collectionName: 'dynamic_legal_entity',
              filters: [
                {
                  fieldName: 'companyName',
                  conditions: [{ type: 'CONTAINS', value: searchMember }],
                },
                {
                  fieldName: 'typeOfLegalEntity',
                  conditions: [
                    {
                      type: 'EQUALS',
                      value: 'ADHERENT',
                    },
                  ],
                },
                {
                  fieldName: 'status',
                  conditions: [
                    {
                      type: 'EQUALS',
                      value: 'Publié',
                    },
                  ],
                },
              ],
              sorts: {
                publishedOrder: 'DESC',
              },
              page: 1,
              pageSize: 5,
            })
            .subscribe((res: any) => {
              this.autocompleteSearchlistMembers = res.content;
            });
        }
      });
  }
  selectItem(item: any) {
    // select item in aucomplete list
    if (item?.code) {
      this.router.navigate(['members/detail-member/' + item?.code]);
    }
  }
  emptyList() {
    setTimeout(() => {
      this.autocompleteSearchlistMembers = [];
    }, 300);
  }
  filterCompany(): void {
    this.formPagination.patchValue({
      page: 1,
    })
    this.getListMember();
  }
  onExport() {
    let filters = [
      {
        fieldName: 'typeOfLegalEntity',
        conditions: [
          {
            type: 'EQUALS',
            value: 'ADHERENT',
          },
        ],
      },
      {
        fieldName: 'status',
        conditions: [
          {
            type: 'EQUALS',
            value: 'Publié',
          },
        ],
      },
    ];

    // Add filters
    if (this.formFilter.value.code) {
      filters.push({
        fieldName: 'code',
        conditions: [{ type: 'CONTAINS', value: this.formFilter.value.code }],
      });
    }
    if (this.formFilter.value.companyName) {
      filters.push({
        fieldName: 'companyName',
        conditions: [{ type: 'CONTAINS', value: this.formFilter.value.companyName }],
      });
    }
    if (this.formFilter.value.postcode) {
      filters.push({
        fieldName: 'postcode',
        conditions: [{ type: 'CONTAINS', value: this.formFilter.value.postcode }],
      });
    }

    const exportFileRequest: any = {
      filters: filters,
      fields: [
        "companyName",
        "address",
        "postcode",
        "city",
        "phone",
        "email",
        "linkToNaturalPersons",
      ],
      relationFields: {
        "linkToNaturalPersons": [
          "civility",
          "lastName",
          "firstName",
          "job",
          "phone",
          "mobile",
          "email"
        ]
      },
      sorts: { companyName: "asc" },
      locales: ["fr_FR"],
    };

    let documentName = 'dynamic_legal_entity';
    let fileExtension = 'xlsx';
    this.dynamicDocumentService
      .exportFileWithContact(documentName, fileExtension, exportFileRequest)
      .subscribe((data: Blob) => {
        const blob = new Blob(
          [data],
          { type: 'application/vnd.ms-excel' }
        );
        const objectUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = `export.xlsx`;
        link.click();
        URL.revokeObjectURL(objectUrl);
      });
  }
}
